/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import * as Array from 'fierry/util/array';


export default class
{
  constructor (scope)
  {
    this.scope = scope;
  }


  // TODO should use a winner not scope.getUserID()!

  getOutgoing ()
  {
    return [];
    /*const found = this.scope.getCass().getDirections().find(entry =>
    {
      return entry.user === this.scope.getInfluences().getWinner();
    });

    return found ? found.directions : [];*/
  }


  // TODO targetIndex / currentIndex can be -1 if it's not adjacent! How to protect against it?
  getOutgoingWithNavigation (navigation)
  {
    let directions = this.getOutgoing().slice();

    if (navigation.isCurrent(this.scope))
    {
      for (const target of navigation.getBehaviorTargets())
      {
        const targetIndex = this.scope.getLocation().getNeighbors().indexOf(target.location);

        if (target.value === 1)
        {
          directions.push(targetIndex);
        }
        else
        {
          Array.erase(directions, targetIndex);
        }
      }
    }

    if (navigation.isTarget(this.scope))
    {
      const target = navigation.getBehaviorTargets().find(target => target.location.equals(this.scope.getLocation()));

      const currentIndex = target.location.getNeighbors().indexOf(navigation.getCurrent());

      if (target.value === 2)
      {
        directions.push(currentIndex);
      }
      else
      {
        Array.erase(directions, currentIndex);
      }
    }

    return directions;
  }


  getOutgoingZones (navigation = null)
  {
    const directions = navigation ? this.getOutgoingWithNavigation(navigation) : this.getOutgoing();

    return this.getZones(directions)
  }


  getIncomming ()
  {
    let results = [];

    const neighbors = this.scope.getLocation().getNeighbors().getZones()

    for (let index = 0; index < neighbors.length; ++index)
    {
      const reverseIndex = (index + 3) % 6;

      if (neighbors[index] && neighbors[index].getDirections().getOutgoing().indexOf(reverseIndex) !== -1)
      {
        results.push(index);
      }
    }

    return results;
  }


  // TODO targetIndex / currentIndex can be -1 if it's not adjacent! How to protect against it?
  getIncommingWithNavigation (navigation)
  {
    let directions = this.getIncomming().slice();

    if (navigation.isCurrent(this.scope))
    {
      for (const target of navigation.getBehaviorTargets())
      {
        const targetIndex = this.scope.getLocation().getNeighbors().indexOf(target.location);

        if (target.value === 2)
        {
          directions.push(targetIndex);
        }
        else
        {
          Array.erase(directions, targetIndex);
        }
      }
    }

    if (navigation.isTarget(this.scope))
    {
      const target = navigation.getBehaviorTargets().find(target => target.location.equals(this.scope.getLocation()));

      const currentIndex = target.location.getNeighbors().indexOf(navigation.getCurrent());

      if (target.value === 1)
      {
        directions.push(currentIndex);
      }
      else
      {
        Array.erase(directions, currentIndex);
      }
    }

    return directions;
  }


  getZones (directions)
  {
    let zones = [];

    const neighbors = this.scope.getLocation().getNeighbors().getZones();

    for (const direction of directions)
    {
      zones.push(neighbors[direction]);
    }

    return zones;
  }


};
